<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.5 4.375V15M9.5 15H6.375M9.5 15H12.625"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.875 6.25H6.70491C6.89897 6.25 7.09036 6.20482 7.26393 6.11803L7.98607 5.75697C8.15964 5.67018 8.351 5.625 8.54506 5.625H10.4549C10.649 5.625 10.8404 5.67018 11.0139 5.75697L11.7361 6.11803C11.9096 6.20482 12.101 6.25 12.2951 6.25H15.125"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.50336 12.2856C3.93078 12.1146 3.69884 11.4661 3.88781 10.8992L5.43754 6.25L6.98726 10.8992C7.17624 11.4661 6.94429 12.1146 6.37172 12.2856C5.74272 12.4736 5.13236 12.4736 4.50336 12.2856Z"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6284 12.2856C12.0558 12.1146 11.8239 11.4661 12.0128 10.8992L13.5625 6.25L15.1123 10.8992C15.3012 11.4661 15.0693 12.1146 14.4967 12.2856C13.8677 12.4736 13.2574 12.4736 12.6284 12.2856Z"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'WeightIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
